import { SET_SELECTED_DOCKET } from './types';

export const setSelectedDocket = (docket) => ({
  type: SET_SELECTED_DOCKET,
  payload: docket,
});